import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface SequenceMetadata {
  event: string;
  sequenceNumber: number;
  date: string;
}

@Injectable({ providedIn: 'root' })
export class EventSequenceService {
  private gapDetected$ = new Subject<SequenceMetadata>();
  readonly onGapDetected = this.gapDetected$.asObservable();

  private sequenceState = new Map<string, {
    lastSequenceNumber: number | null;
    lastSequenceDate: string | null;
  }>();

  checkAndUpdate(
    locationId: string,
    sequenceNumber: number,
    date: string,
    event: string
  ): boolean {
    const state = this.sequenceState.get(locationId) || {
      lastSequenceNumber: null,
      lastSequenceDate: null,
    };

    if (date !== state.lastSequenceDate) {
      this.sequenceState.set(locationId, {
        lastSequenceNumber: sequenceNumber,
        lastSequenceDate: date,
      });

      return false;
    }

    const hasGap =
      state.lastSequenceNumber !== null &&
      sequenceNumber > state.lastSequenceNumber + 1;

    if (hasGap && state.lastSequenceNumber !== null) {
      const gap = sequenceNumber - state.lastSequenceNumber - 1;
      console.warn(
        `Gap detected!`,
        `\n  Event: ${event}`,
        `\n  Missing: ${gap} events`,
        `\n  Expected: ${state.lastSequenceNumber + 1}`,
        `\n  Got: ${sequenceNumber}`
      );

      this.gapDetected$.next({ event, sequenceNumber, date });
    }

    this.sequenceState.set(locationId, {
      lastSequenceNumber: sequenceNumber,
      lastSequenceDate: date,
    });

    return hasGap;
  }

  reset(locationId: string): void {
    this.sequenceState.delete(locationId);
  }

  getState(locationId: string) {
    return this.sequenceState.get(locationId);
  }
}
